// Compatibility shim so vendored TySoce modules can do:
//   import { useAuth } from '@/auth/AuthContext'
// without us spinning up a second AuthProvider. We map the main app's
// AuthContext (which lives at @/contexts/AuthContext.jsx) into the shape
// TySoce expects: { user, loading, login, logout }.
import { useAuth as useMainAuth } from "@/contexts/AuthContext";

export function useAuth() {
  const { admin, verifying, login, logout } = useMainAuth();
  return {
    user: admin
      ? { id: admin.email, email: admin.email, name: "Admin", role: admin.role || "admin" }
      : null,
    loading: verifying,
    login,
    logout,
  };
}

// A few TySoce files reference `AuthProvider` from this module. We expose a
// no-op passthrough so any stray imports don't crash; the real provider is
// mounted at the top of the main App.js.
export function AuthProvider({ children }) {
  return children;
}
